import React, { useState, useEffect } from 'react'; 
import StepFooter from 'components/presenters/footer/StepFooter';
import plus_icon from 'images/plus_icon.png';
import dotbtn from 'images/dotbtn.png';
import Bottom_Modal_var2 from 'components/modal/Bottom_Modal_var2';
import { removeItem } from 'utils/utils.js';

import ProjectSettingTodoListInput from 'components/containers/group/project/ProjectSettingTodoListInput';
import {
  CampaignTitleInner,
  Listbox,
  ListboxTit,
  VerificationInner,
  TodoInputBoxArea,
  Addbtn,
  Notitext,
  Pjtodoinner,
  Maintit,
  Subtit,
} from './style';

// 하단 모달 창 리스트
let modallist = [{ text: '삭제', color: '#de0000' }];

export default function ProjectSettingTodoListStep({
  updateNext,
  inputlist,
  setInputlist,
  removedTaskList,
  setRemovedTaskList,
}) {
  const [modalShow, setModalShow] = useState(false);
  const [next, setNext] = useState(false);
  const [change, setChange] = useState(false);
  const [selectIndex, setSelectIndex] = useState(-1);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [showTimeModal, setShowTimeModal] = useState(false);

  const todotextVaildate = () => {
    return inputlist && inputlist[0] && inputlist[0].title != null;
  };

  useEffect(() => {
    if (todotextVaildate()) setNext(true);
    else setNext(false);
  }, [inputlist]);

  const addlist = () => {
    let tempList = inputlist;
    tempList.push({
      title: null,
      start_date: null,
      end_date: null,
      day: null,
      time: null,
      alarm_time: null,
    });
    setInputlist(tempList);
    setChange(!change);
  };

  const modalOpenClick = (e, index) => {
    setModalShow(true);
    setSelectIndex(index);
  };

  const init = () => {
    modallist[0].clickEvent = () => {
      setModalShow(false);
      let currSelectedItem = inputlist[selectIndex];
      if (setRemovedTaskList && removedTaskList) {
        if (currSelectedItem['no']) {
          setRemovedTaskList([...removedTaskList, currSelectedItem]);
        }
      }

      let list = [];
      list = removeItem(inputlist, selectIndex);
      setInputlist(list);
      setChange((e) => !e);
    };
  };
  init();

  function getTodoList() {
    if (inputlist)
      return inputlist.map((value, index) => {
        const openTimeModal = () => {
          setShowTimeModal(true);
          if (showTimeModal != true) setCurrentIndex(index);
        };

        return (
          <ProjectSettingTodoListInput
            key={`project-todolist-indeox-${index}`}
            openTimeModal={openTimeModal}
            value={value}
            change={change}
            index={index}
            setInputlist={setInputlist}
            clickModal={modalOpenClick}
          />
        );
      });
    else return null;
  }

  const timeChange = (e) => {
    //setCalTimeSelcet(e);
    let hour = parseInt(e.hour) + (e.day == 'AM' ? 0 : 12);
    setInputlist((list) => {
      let tempList = JSON.parse(JSON.stringify(list));
      tempList[currentIndex].time =
        (hour == 24 ? '00' : hour) + ':' + e.minute + ':' + '00';
      return tempList;
    });
  };

  return (
    <Pjtodoinner>
      <Maintit>함께하는 투두리스트 설정</Maintit>
      <Subtit>
        {' '}
        멤버들의 필수 투두리스트를 설정하는 기능입니다.
        <br /> 같은 목표를 이루어 나가며 서로에게 동기부여가 될 수 있습니다.
      </Subtit>
      <CampaignTitleInner>
        <Listbox>
          <ListboxTit>
            아래 리스트는 내 투두리스트에 자동 저장 됩니다.{' '}
          </ListboxTit>
          <VerificationInner>
            <TodoInputBoxArea>{getTodoList()}</TodoInputBoxArea>
            <Addbtn onClick={addlist}>
              <img src={plus_icon} />
            </Addbtn>
            <Notitext
              style={{
                marginBottom: ' calc(100vw*(5/375))',
                paddingTop: ' calc(100vw*(21/375))',
              }}
            >
              *시간설정은 선택사항입니다
            </Notitext>
            <Notitext>
              *시간이 지정된 투두리스트는 해당 시간으로부터 10분 이내에
              인증해야만
              <br />
              성공으로 간주됩니다.{' '}
            </Notitext>
          </VerificationInner>
        </Listbox>
      </CampaignTitleInner>
      {next ? (
        <StepFooter
          text={'4 / 5'}
          color={'#4e4e4e'}
          position={'fixed'}
          prevdisplay={'flex'}
          nextdisplay={'flex'}
          updateNext={updateNext}
          next={next}
        />
      ) : (
        <StepFooter
          text={'4 / 5'}
          color={'#4e4e4e'}
          position={'fixed'}
          prevdisplay={'flex'}
          nextdisplay={'flex'}
          updateNext={updateNext}
          bg={'#d8d8d8'}
          next={false}
        />
      )}
      <Bottom_Modal_var2
        data={modallist}
        cancle={true}
        show={modalShow} //모달 보여지는 여부
        setModalShow={setModalShow}
        //   path={`/Fitgroup`}
      />
    </Pjtodoinner>
  );
}
